import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { ResourceService } from "../../../core/services/resource.service";
import { filter, from, map, Observable, switchMap } from "rxjs";
import { Rds } from "../models/rds";
import { AppConfigService } from "src/app/app-config.service";
import {
  ConfirmDialogComponent,
  ConfirmDialogConfig,
} from "../components/confirm-dialog/confirm-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { AlertDialog, AlertDialogConfig } from "../components/alert/dialog";

@Injectable({ providedIn: "root" })
export class RdsService extends ResourceService<Rds> {
  constructor(
    private readonly dialog_: MatDialog,
    private http: HttpClient,
    private configService: AppConfigService,
  ) {
    super(http, Rds, "rds");
  }

  public start(object: any): Observable<any> {
    const config = {
      title: "Confirmer le démarrage de la ressource",
      message:
        "Souhaitez-vous confirmer le démarrage de la ressource " +
        object.DBName +
        " (" +
        object.DBInstanceIdentifier +
        ") ?",
    } as ConfirmDialogConfig;

    return this.dialog_
      .open(ConfirmDialogComponent, { data: config })
      .afterClosed()
      .pipe(
        filter((result) => result),
        switchMap((_) => {
          return from(
            this.api.put("route-api", `rds/${object.DBInstanceIdentifier}/start`, {
              body: {
                resourceARN: object.DBInstanceArn,
              },
            })
          ).pipe(
            map((response) => {
              if (!response.status) {
                const config = {
                  title: "Erreur",
                  message:
                    "Une erreur est survenue lors du démarrage de la ressource : " +
                    object.DBName +
                    " (" +
                    object.DBInstanceIdentifier +
                    "). " +
                    response.message,
                  confirmLabel: "OK",
                } as AlertDialogConfig;
                this.dialog_.open(AlertDialog, { data: config });
                throw new Error(response.message);
              } else {
                const config = {
                  title: "Démarrage en cours",
                  message: `L'instance ${object.DBName || object.DBInstanceIdentifier} (${object.DBInstanceIdentifier}) démarre. Son état est suivi dans la colonne État.`,
                  confirmLabel: "OK",
                } as AlertDialogConfig;
                this.dialog_.open(AlertDialog, { data: config });
                return response;
              }
            })
          );
        })
      );
  }

  public stop(object: any): Observable<any> {
    console.log(" Object to stop : ", object);
    const config = {
      title: "Confirmer l'arrêt de la ressource",
      message:
        "Souhaitez-vous confirmer l'arrêt de la ressource " +
        object.DBName +
        " (" +
        object.DBInstanceIdentifier +
        ") ?",
    } as ConfirmDialogConfig;

    return this.dialog_
      .open(ConfirmDialogComponent, { data: config })
      .afterClosed()
      .pipe(
        filter((result) => result),
        switchMap((_) => {
          return from(
            this.api.put("route-api", `rds/${object.DBInstanceIdentifier}/stop`, {
              body: {
                resourceARN: object.DBInstanceArn,
              },
            })
          ).pipe(
            map((response) => {
              if (!response.status) {
                const config = {
                  title: "Erreur",
                  message:
                    "Une erreur est survenue lors de l'arrêt de la ressource : " +
                    object.DBName +
                    " (" +
                    object.DBInstanceIdentifier +
                    "). " +
                    response.message,
                  confirmLabel: "OK",
                } as AlertDialogConfig;
                this.dialog_.open(AlertDialog, { data: config });
                throw new Error(response.message);
              } else {
                const config = {
                  title: "Arrêt en cours",
                  message: `L'instance ${object.DBName || object.DBInstanceIdentifier} (${object.DBInstanceIdentifier}) s'arrête. Son état est suivi dans la colonne État.`,
                  confirmLabel: "OK",
                } as AlertDialogConfig;
                this.dialog_.open(AlertDialog, { data: config });
                return response;
              }
            })
          );
        })
      );
  }

  public getByGroup(group_id: string): Observable<Rds[]> {
    return from(
      this.api.get("route-api", `${this.apiUrl}?group=${group_id}`, {}),
    ).pipe<any>(map((result) => result.resource));
  }
}